import { QueryDefinition } from '@reduxjs/toolkit/query'

import { baseQueryWithNotifications } from '@redux/api/config'

import { URLS } from '@constants'
import { ActionRow, GETContainerEnrichedDTO } from '@types'

import { fetchTooltipConfigsFromActions } from './fetchTooltipConfigsFromActions'

type FetchContainerFn = QueryDefinition<
  {
    cacheId?: string
    formCode: string
  },
  typeof baseQueryWithNotifications,
  string,
  GETContainerEnrichedDTO[],
  'commonApi'
>['queryFn']

export const fetchEnrichedContainerConfig: NonNullable<FetchContainerFn> = async (
  { formCode },
  api,
  _,
  baseQuery
) => {
  const queryResult = await baseQuery({
    url: URLS.FRONT_CFG + `/container/enriched/form/code/${formCode}`,
    method: 'GET',
  })

  if (queryResult.error) {
    return { error: queryResult.error }
  }

  const containers = queryResult.data as GETContainerEnrichedDTO[]

  const allActions: ActionRow[] = []
  containers.forEach(container => {
    container.tabs?.forEach(tab => {
      tab.lines?.forEach(line => {
        line.elements?.forEach(element => {
          element.formToLcConnections?.forEach(connection => {
            if (connection.actions) {
              allActions.push(...connection.actions)
            }
          })
        })
      })
    })
  })

  const tooltips = await fetchTooltipConfigsFromActions({ actions: allActions, api })

  const enrichedContainers = containers.map(container => ({
    ...container,
    tabs: container.tabs?.map(tab => ({
      ...tab,
      lines: tab.lines?.map(line => ({
        ...line,
        elements: line.elements?.map(element => ({
          ...element,
          formToLcConnections: element.formToLcConnections?.map(connection => ({
            ...connection,
            actions: connection.actions?.map(action => {
              if (action.objectTooltipId && tooltips.has(action.objectTooltipId)) {
                return { ...action, tooltip: tooltips.get(action.objectTooltipId) }
              }

              return action
            }),
          })),
        })),
      })),
    })),
  }))

  return { data: enrichedContainers }
}
